/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/tanqueCheio/components/ImageOptionsModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  ImageOptionsModalPaper,
  ImageOptionsModalTitle,
  ImageOptionsModalContent,
  ImageOptionsModalStationName,
  ImageOptionsModalButtonsContainer,
  ImageOptionsModalVerButton,
  ImageOptionsModalSubstituirButton,
  ImageOptionsModalRemoverButton,
} from './styles';

const ImageOptionsModal = ({ 
  open, 
  onClose, 
  stationName,
  onSubstituir,
  onRemover,
  onVer
}) => {

  const handleSubstituir = () => {
    onSubstituir();
    onClose();
  };

  const handleRemover = () => {
    onRemover();
    onClose();
  };

  const handleVer = () => {
    onVer();
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: ImageOptionsModalPaper }}
    >
      <DialogTitle sx={ImageOptionsModalTitle}>
        <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
          Opções de Imagem
        </Typography>
        <IconButton 
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={ImageOptionsModalContent}>
        <Typography variant="body2" color="text.secondary" sx={ImageOptionsModalStationName}>
          {stationName}
        </Typography>

        <Box sx={ImageOptionsModalButtonsContainer}>
          <Button
            variant="outlined"
            startIcon={<VisibilityIcon />}
            onClick={handleVer}
            sx={ImageOptionsModalVerButton}
          >
            Ver Imagem
          </Button>

          <Button
            variant="outlined"
            startIcon={<SwapHorizIcon />}
            onClick={handleSubstituir}
            sx={ImageOptionsModalSubstituirButton}
          >
            Substituir Imagem
          </Button>

          <Button
            variant="outlined"
            startIcon={<DeleteIcon />}
            onClick={handleRemover}
            sx={ImageOptionsModalRemoverButton}
          >
            Remover Imagem
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

ImageOptionsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  stationName: PropTypes.string,
  onSubstituir: PropTypes.func.isRequired,
  onRemover: PropTypes.func.isRequired,
  onVer: PropTypes.func.isRequired,
};

export default ImageOptionsModal;
